// SHA-256 (hex) of a note's text, as the API names note versions
// (noteVersion in apps/api/src/services/note-assistant/note-proposal.ts).
export const noteHash = async (
  text: string | null | undefined,
): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(text ?? ""),
  );
  return Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
};
